<template>
  <b-modal
    v-model="isVisible"
    :title="$t('general.imagePreview')"
    hide-footer
    centered
    size="lg"
    content-class="image-preview-modal-content"
    @hidden="onHidden"
  >
    <div class="image-preview-modal">
      <div class="image-container">
        <img
          v-if="imageUrl && !loadError"
          ref="imageElement"
          class="image-element"
          :src="imageUrl"
          :alt="imageAlt"
          @error="handleImageError"
        />
        <div v-else-if="loadError" class="error-message">
          <feather-icon icon="AlertTriangleIcon" size="40" />
          <p>{{ $t('general.imageLoadError') }}</p>
        </div>
        <div v-else class="loading-message">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
          <p>{{ $t('general.loading') }}</p>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BSpinner,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default {
  name: 'ImagePreviewModal',

  components: {
    BModal,
    BSpinner,
    FeatherIcon,
  },

  props: {
    // Image URL to display
    imageUrl: {
      type: String,
      default: '',
    },
    // Image alt text
    imageAlt: {
      type: String,
      default: 'Image preview',
    },
    // Whether the modal is visible
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loadError: false,
    }
  },

  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    value(newValue) {
      if (newValue) {
        // Reset state when modal is opened
        this.loadError = false
      }
    },

    imageUrl() {
      // Reset error state when image URL changes
      this.loadError = false
    },
  },

  methods: {
    handleImageError() {
      this.loadError = true
    },

    onHidden() {
      this.$emit('hidden')
    },
  },
}
</script>

<style lang="scss" scoped>
.image-preview-modal {
  .image-container {
    position: relative;
    width: 100%;
    background-color: #f8f9fa;
    border-radius: 8px;
    overflow: hidden;
    text-align: center;
    min-height: 200px;
    max-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .image-element {
      max-width: 100%;
      max-height: 70vh;
      object-fit: contain;
    }

    .error-message {
      padding: 2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #f8d7da;
      color: #721c24;

      p {
        margin-top: 1rem;
        font-weight: 500;
      }
    }

    .loading-message {
      padding: 2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #f8f9fa;
      color: #6c757d;

      p {
        margin-top: 1rem;
        font-weight: 500;
      }
    }
  }
}
</style>

<style lang="scss">
.image-preview-modal-content {
  border-radius: 12px;
  overflow: hidden;

  .modal-header {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #e9ecef;

    .modal-title {
      font-weight: 600;
      font-size: 1.1rem;
    }
  }

  .modal-body {
    padding: 1.5rem;
  }
}
</style>
